<template>
  <TableViewerComponent :data="data" />
</template>
<script>
import {
  defineComponent, provide, reactive, watch, inject,
} from 'vue';

import TableViewerComponent from './TableViewerComponent.vue';
import { TableViewerOpenedTabsState } from '../common/table-viewer';

export default defineComponent({
  components: { TableViewerComponent },
  props: {
    highlightPath: { type: String, default: null },
    scrollRef: { type: Object, default: null },
    data: { type: Object, default: null },
  },
  setup(props) {
    const { data } = props;

    const tabsState = reactive({ set: new Set(), counter: 0 });
    provide(TableViewerOpenedTabsState, tabsState);

    let backupSet;

    const printRef = inject('printRef');

    watch(printRef, (newValueRef, oldValueRef) => {
      const newValue = newValueRef.value;
      const oldValue = oldValueRef.value;
      if (newValue === oldValue) return;

      if (newValue) {
        // beforePrint
        backupSet = tabsState.set;
        tabsState.set = new Set();
      } else {
        // afterPrint
        tabsState.set = backupSet;
        backupSet = null;
      }
    });

    return { data };
  },
});
</script>
